import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastNotificationsService } from '@app/shared/services/toast-notifications/toast-notifications.service';
import { MyBusinessRoutes } from '../../interfaces/constants';

@Component({
  selector: 'sbnb-transaction-edit',
  templateUrl: './transaction-edit.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransactionEditComponent implements OnInit {
  public recurring = this.route.snapshot.params.recurring === 'recurring';
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private toast: ToastNotificationsService
  ) {}

  ngOnInit(): void {}

  onSave() {
    this.router.navigate([MyBusinessRoutes.Transactions]);
    this.toast.success('Transaction updated!');
  }
}
